exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sk-rotating-plane {\n    position: relative;\n    top: 50%;\n    width: 40px;\n    height: 40px;\n    margin: auto;\n    animation: sk-rotateplane 1.2s infinite ease-in-out;\n}\n\n@keyframes sk-rotateplane {\n    0% {\n        transform: perspective(120px) rotateX(0deg) rotateY(0deg);\n        -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg)\n    }\n    50% {\n        transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);\n        -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg)\n    }\n    100% {\n        transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\n        -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\n    }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/yaratechnologies/talkative-parents-portal/src/app/spinner/spinkit-css/sk-rotating-plane.css
// module id = ../../../../../src/app/spinner/spinkit-css/sk-rotating-plane.css
// module chunks = main